import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Modal, Card, Nav, Button, Row, Col } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import FalconCloseButton from 'components/common/FalconCloseButton';
import RegionMap from './RegionMap';
import NavItem from 'components/common/NavItem';
import DefinePropertyBoundary from './define-property-boundary';
import {
  prevState,
  nextState,
  reset,
  setShowEditControl,
  setDrawingFence
} from 'reducers/livingCarbonGrantReducer';
import Requirements from './requirements';
import Planting from './planting';
import dayjs from 'dayjs';
import SummaryReportComparison from 'components/app/landdev/summary-report-comparison';

const GenerateGrantModal = ({ show, onClose }) => {
  const dispatch = useDispatch();
  const {
    steps,
    currentState,
    selectedLandParcels,
    developPlantingSite,
    plantingSites,
    fence
    // photoMonitoringPoint
  } = useSelector(state => state.livingCarbonGrant);

  const [itemType, setItemType] = useState(0);

  const {
    // control,
    // register,
    // watch,
    formState: { errors },
    setError,
    clearErrors
    // handleSubmit,
    // reset: resetForm
  } = useForm();

  const editRef = useRef(null);

  const setEditRef = ref => {
    editRef.current = ref;
  };

  const handleClose = () => {
    onClose();
    dispatch(reset());
    // resetForm();
  };

  const handlePrevious = () => {
    dispatch(prevState());
  };

  const handleSubmit = () => {
    dispatch(nextState());
  };

  // setTimeout() is required to activate draw tools upon first click
  const handleDrawPlanting = type => {
    dispatch(setShowEditControl(true));
    setItemType(type);
    switch (type) {
      case 3:
        // new fence
        dispatch(setDrawingFence(0));
        setTimeout(() => {
          editRef.current._toolbars.draw._modes.polyline.handler.enable();
        }, 150);
        break;

      case 4:
        // existing fence
        dispatch(setDrawingFence(1));
        setTimeout(() => {
          editRef.current._toolbars.draw._modes.polyline.handler.enable();
        }, 150);
        break;

      default:
        setTimeout(() => {
          editRef.current._toolbars.draw._modes.polygon.handler.enable();
        }, 150);

        break;
    }
  };

  const currentDate = dayjs(Date.now()).format('DD MMM YYYY');

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        fullscreen
      >
        <Modal.Header>
          <Modal.Title>
            Generate a Living Carbon Grant - {currentDate}
          </Modal.Title>
          <FalconCloseButton onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <Card className={classNames('theme-wizard h-100')}>
            <Card.Header className={classNames('bg-body-tertiary', 'pb-2')}>
              <Nav className="justify-content-center">
                {steps.map((item, index) => (
                  <NavItem
                    key={item.label}
                    index={index + 1}
                    step={currentState}
                    stepCount={steps.length}
                    handleNavs={() => {}}
                    icon={item.icon}
                    label={item.label}
                  />
                ))}
              </Nav>
            </Card.Header>
            <Card.Body className="fw-normal px-md-6 py-4">
              <Row className="g-3 mb-3 h-100">
                {(currentState === 1 || currentState === 2) && (
                  <>
                    <Col lg={6}>
                      <RegionMap
                        onEditMounted={setEditRef}
                        itemType={itemType}
                      ></RegionMap>
                    </Col>
                    <Col lg={6}>
                      {currentState === 1 && (
                        <DefinePropertyBoundary
                          errors={errors}
                          setError={setError}
                          clearErrors={clearErrors}
                          selectedLandParcels={selectedLandParcels}
                        />
                      )}
                      {currentState === 2 && (
                        <>
                          {developPlantingSite === -1 ? (
                            <Requirements
                              onDrawPlantingSite={handleDrawPlanting}
                            />
                          ) : (
                            <Planting editRef={editRef} />
                          )}
                        </>
                      )}
                      {/* {currentState === 3 && <Planting />} */}
                    </Col>
                  </>
                )}

                {currentState === 3 && (
                  <Col lg={12}>
                    <SummaryReportComparison />
                  </Col>
                )}
              </Row>
            </Card.Body>
          </Card>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleClose}>
            Close
          </Button>

          <Button
            variant="outline-primary"
            disabled={currentState === 1}
            onClick={() => handlePrevious()}
          >
            Previous
          </Button>

          <Button
            type="button"
            variant="outline-primary"
            disabled={
              (currentState === 1 && selectedLandParcels.length < 1) ||
              (currentState === 2 &&
                (plantingSites.length === 0 || fence.length === 0))
              // photoMonitoringPoint.length === 0
            }
            onClick={() => handleSubmit()}
          >
            {currentState < steps.length ? 'Next' : 'Submit'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

GenerateGrantModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};
export default GenerateGrantModal;
